import React from 'react';
import '../../../App.css';
import Spacer from '../../../components/Spacer';

import ComponentCategoryInfomation from '../ComponentCategoryInfomation';
import ComponentHoverLinkTile from '../mini_components/ComponentHoverLinkTile';
import ComponentProfileTile from '../../Profile/ComponentProfileTile';


const ComponentProductHeader = ({
    isDesktop,
    data,
    customImageSize = '40%',
    customImageAlign='center'
}) => {
    return (
        <div style={{
            display: 'flex',
            textAlign: 'center',
            flexDirection: (isDesktop) ? 'row' : 'column',
            justifyContent: 'space-between',
            alignItems: (isDesktop) ? 'start' : 'center',
            width: '100%'
        }}>
            {/* -------------------- 画像 ----------------------- */}
            <div style={{
                width: (isDesktop) ? customImageSize : '90%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: customImageAlign,
                marginBottom: (isDesktop) ? '0' : '20px'
            }}>
                {(data.image)
                    ? <img
                        src={data.image}
                        alt="画像"
                        style={{ width: '70%' }}
                    />
                    : <div style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <p style={{ fontSize: "200%", textAlign: 'center' }}>ー</p>
                    </div>
                }
            </div>
            {/* ------------------------------------------------- */}
            <div style={{
                width: (isDesktop) ? '55%' : '90%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start'
            }}>
                {/* ----------------- ジャンル表示 -------------------- */}
                <ComponentCategoryInfomation kind={data.kind} customBackgroundColor='var(--common-back-color)' />
                {/* ------------------------------------------------- */}
                {/* ------------------ タイトル ---------------------- */}
                <h2
                    style={{ color: 'var(--common-main-color)', fontSize: '45px' }}
                >
                    {data.title.split("\n").map((line, index) => (
                        <React.Fragment key={index}>
                            {line}
                            {index !== data.title.split("\n").length - 1 && <br />}
                        </React.Fragment>
                    ))}
                </h2>
                {/* ------------------------------------------------- */}

                {/* -------------- キャプション(月日) ------------------ */}
                <p style={{ fontSize: '95%', color: 'var(--common-main-color)' }}>
                    {
                        (data.isDateStart)
                            ? (data.year && data.month)
                                ? <>{data.year}年{data.month}月-</>
                                : (data.year && !data.month)
                                    ? <>{data.year}年-</>
                                    : null
                            : (!data.isDateStart)
                                ? (data.year && data.month)
                                    ? <>{data.year}年{data.month}月</>
                                    : (data.year && !data.month)
                                        ? <>{data.year}年</>
                                        : null
                                : null
                    }
                </p>
                {/* ------------------------------------------------- */}
                <Spacer height={14} />
                {/* -------------- メインキャプション ------------------ */}
                <p>{data.subtitle}</p>
                {/* ------------------------------------------------- */}
                <Spacer height={7} />
                {/* -------------- サブキャプション ------------------- */}
                <p style={{ textAlign: 'left' }}>{
                    (typeof data.detailTitle === 'string')
                    ? data.detailTitle
                    : (Array.isArray(data.detailTitle))
                        ? <>{data.detailTitle.map((text, index) => <p key={index}>
                            {text}
                        </p>)}</>
                        : null
                }</p>
                {/* ------------------------------------------------- */}
                <Spacer height={20} />
                {/* ----------------- 詳細リンク --------------------- */}
                {(typeof data.detailLinks === 'string')
                    ? data.detailLinks
                    : (Array.isArray(data.detailLinks))
                        ? <div style={{ display: 'flex', flexWrap: 'wrap', gap: '3px 7px', justifyContent: (isDesktop) ? null : 'center' }}>
                            {data.detailLinks.map((link, index) => (
                                <ComponentHoverLinkTile
                                    icon={link.icon}
                                    title={link.title}
                                    subtitle={link.subtitle}
                                    url={link.url}
                                    isPreparing={link.isPreparing}
                                    isSubtitleColumn={link.isSubtitleColumn}
                                    customPreparingMessage={link.customPreparingMessage}
                                    isHoverType={false}
                                />
                            ))}
                        </div>
                    : null
                }
                {/* ------------------------------------------------- */}
                <Spacer height={7} />
                {/* ----------------- 許可未取得明記 ------------------- */}
                {data.isNotCodeAllowed &&
                    <p style={{ fontSize: "75%"}}>※ 許可未取得のためGitHubリポジトリやソースコードは未掲載</p>
                }
                {/* ------------------------------------------------- */}



                <Spacer height={40} />
                {/* ----------------- 詳細タイル --------------------- */}
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    {(typeof data.detailTiles === 'string')
                    ? data.detailTiles
                    : (Array.isArray(data.detailTiles))
                        ? <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            flexDirection: 'column',
                            gap: '0 7px',
                            justifyContent: 'center',
                            width: '100%'
                        }}>{data.detailTiles.map((detail, index) => (
                            (Array.isArray(detail.content) === true)
                                ? <div style={{
                                    width: '90%'
                                    }}><ComponentProfileTile
                                    key={index}
                                    title={detail.title}
                                    text={detail.content ?? []}
                                    minHeight="80px"
                                /></div>
                                : <div style={{
                                    width: '90%'
                                    }}><ComponentProfileTile
                                    key={index}
                                    title={detail.title}
                                    text={detail.content}
                                    minHeight="80px"
                                /></div>
                        ))}</div>
                        : null
                    }
                    {/* - - - スキルタイル - - - */}
                    {(data.experienceTiles != null && Array.isArray(data.experienceTiles))
                        ? <div style={{width: '90%'}}><ComponentProfileTile
                            title="磨いたスキル"
                            text={data.experienceTiles}
                        /></div>
                        : null
                    }
                    {/* - - - - - - - - - - - -*/}
                </div>
                {/* ------------------------------------------------- */}
            </div>
        </div>
    );
};

export default ComponentProductHeader;
